import React from 'react';
import paging from '@/hooks/paging';
import { fetchRequestCohorts, toggleRequestCohortSelected } from '../actions';
import { newRequest, resolveRequestWorkflow } from '../../state/state';

const RequestCohortsContainer = ({
  category,
  children,
  code,
  fetchData,
  readStatus,
}) => {
  paging.useFetchByCode(fetchData, category, code, readStatus);
  return (<>{children}</>);
};

export const mapStateToProps = ({
  auth: { role: { permissions: { cohorts: { create } } } },
  cohorts: { newCohortCode },
  requests: { requests },
  themes: { theme },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, newRequest(ownProps));
  const { cohorts } = request.steps;

  return ({
    canCreate: create,
    cohorts: cohorts.results,
    currentPage: cohorts.currentPage,
    filterTerm: cohorts.filter,
    newCohortCode,
    pageCount: cohorts.totalPages,
    pageSize: cohorts.pageSize,
    readErrors: cohorts.readErrors,
    readStatus: cohorts.readStatus,
    theme,
    total: cohorts.count,
  });
};

export const mapDispatchToProps = {
  fetchData: fetchRequestCohorts,
  onCheckBoxClick: toggleRequestCohortSelected,
};

export default RequestCohortsContainer;
